div.fields
if isEditable
    a.btn.btn-muted.btn-block.add-field(data-action="add-field")
        i.fa.fa-plus
        span &nbsp;Add a field
